/* =========================================================
   PLATFORM
========================================================= */

import React from "react";
import Workflow from "./Workflow";

const PlatformSection = ({ data }) => (
    <section className="home-platform-section" id="platform">

        <div className="container">

            <div className="home-platform-grid">

                <div>

                    <div className="eyebrow">
                        {data.eyebrow}
                    </div>

                    <h2 className="home-platform-title">
                        {data.title}
                    </h2>

                    <p className="home-platform-description">
                        {data.description}
                    </p>

                    <div className="buttons">

                        <a
                            href={data.primaryUrl || "#"}
                            className="btn btn-primary"
                        >
                            {data.primaryText || "Explore Platform"}
                        </a>

                    </div>

                </div>

                <div className="home-platform-panel">

                    {(data.items || []).map((item, i) => (
                        <div className="home-platform-row" key={i}>

                            <div className="home-platform-icon">
                                {item.icon}
                            </div>

                            <div>
                                <strong>{item.title}</strong>
                                <span>{item.description}</span>
                            </div>

                        </div>
                    ))}

                </div>

            </div>

            <Workflow data={data.workflow || []} />

        </div>

    </section>
);

export default PlatformSection;